export enum FinanceDetailsRows {
  DEPOSIT = 'deposit',
  DEPOSIT_PERCENTAGE = 'depositPercentage',
  RESIDUAL_AMOUNT = 'residualAmount',
  AMOUNT_FINANCED = 'amountFinanced',
  PAYMENT_VALUE = 'paymentValue',
  FINANCE_PRODUCT_NAME = 'financeProductName',
  TERM = 'term',
  MILEAGE = 'mileage',
  AMOUNT_PAYABLE = 'amountPayable',
  DISCLAIMER = 'disclaimer',
  TOTAL_AMOUNT_PAYABLE = 'totalAmountPayable',
  INTEREST_RATE = 'interestRate',
  NET_DRIVEAWAY_PRICE = 'netDriveawayPrice',
  UPFRONT_FEES = 'upfrontFees',
  LOAN_TYPE = 'loanType',
  COMPARISON_RATE = 'comparisonRate',
  ON_ROAD_COSTS = 'onRoadCosts',

  REPAYMENT = 'repayment',
  RESIDUAL_PAYMENT = 'residualPayment',
  TOTAL_PURCHASE_AMOUNT = 'totalPurchaseAmount',
  ESTABLISHMENT_FEE = 'establishmentFee',
  LOAN_TERM_PERIOD = 'loanTermPeriod',
  GOVERNMENT_EV_REBATE = 'governmentEVRebate',

  NONFINANCEABLE_AMOUNT = 'totalNonFinanceableFeatures',
}
